import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';

import {
  OfferTypes,
  cancelFlow_offerResultScreenLoad,
  cancelFlow_cancelResultClick,
} from 'services/analytics/trackers/cancelFlow';

import { useCancelSubscription, useModals } from 'hooks';

import Modal from 'components/Modal/Modal';
import { Button, Text } from 'components/library';
import * as S from './styled';
import MailImage from './img/mail.svg';

const ReminderHasBeenSetModalContainer = () => {
  const { t } = useTranslation();
  const { closeModal } = useModals();
  const { cancellationCandidate } = useCancelSubscription();

  useEffect(() => {
    cancelFlow_offerResultScreenLoad({
      result: 'success',
      offer_type: OfferTypes.Reminder_offer,
      subscription_id: cancellationCandidate?.external_id,
    });
  }, []);

  const handleClose = () => {
    if (cancellationCandidate) {
      cancelFlow_cancelResultClick({
        result: 'success',
        action: 'continue',
        subscription_id: cancellationCandidate.external_id,
      });
    }

    closeModal();
  };

  return (
    <Modal isOpen withCloseButton onClose={handleClose}>
      <S.Container $paddingTop={24} $paddingBottom={24} $paddingX={16}>
        <MailImage />
        <Text type="h5" bold center mb={24}>
          {t('subscription.reminderHasBeenSetModal.title')}
        </Text>
        <Text type="medium-text" center mb={24}>
          {t('subscription.reminderHasBeenSetModal.subTitle')}
        </Text>
        <Button onClick={handleClose} backgroundColor="primary-default" dataLocator="obContinue">
          {t('basics.continue')}
        </Button>
      </S.Container>
    </Modal>
  );
};

export default ReminderHasBeenSetModalContainer;
